import LogoComponent from "./logo";
import { BsFacebook, BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
export const Footer = () => {
  return (
    <div className="flex items-end w-full bg-white">
      <footer className="w-full bg-gray-100 body-font">
        <div className="container flex flex-col flex-wrap px-5 py-12 mx-auto md:items-start lg:items-start md:flex-row md:flex-no-wrap">
          <div className="flex-shrink-0 w-64 mx-auto text-center md:mx-0 md:text-left">
            <div className="flex items-center justify-center font-medium title-font md:justify-start">
              <div className="flex flex-shrink-0 items-center">
                <LogoComponent placement="footer" />
              </div>
            </div>
            <p className="mt-2 text-sm text-gray-600">
              Parcel Delivery, Done Right
            </p>
            <div className="mt-4">
              <span className="inline-flex justify-center mt-2 sm:ml-auto sm:mt-0 sm:justify-start gap-3">
                <div className="text-purple-600 cursor-pointer hover:text-purple-800 transition-colors">
                  <BsFacebook className="w-5 h-5" />
                </div>
                <div className="text-purple-600 cursor-pointer hover:text-purple-800 transition-colors">
                  <BsTwitter className="w-5 h-5" />
                </div>
                <div className="text-purple-600 cursor-pointer hover:text-purple-800 transition-colors">
                  <BsInstagram className="w-5 h-5" />
                </div>
                <div className="text-purple-600 cursor-pointer hover:text-purple-800 transition-colors">
                  <BsLinkedin className="w-5 h-5" />
                </div>
              </span>
            </div>
          </div>
          <div className="flex flex-wrap flex-grow mt-10 -mb-10 text-center md:pl-20 md:mt-0 md:text-left">
            <div className="w-full px-4 lg:w-1/4 md:w-1/2">
              <h2 className="mb-3 text-sm font-semibold tracking-widest text-purple-800 uppercase">
                Company
              </h2>
              <nav className="mb-10 list-none">
                <li className="mt-2">
                  <a
                    href="/about-us"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    About Us
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/how-it-works"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    How It Works
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/contact"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    Contact
                  </a>
                </li>
              </nav>
            </div>
            <div className="w-full px-4 lg:w-1/4 md:w-1/2">
              <h2 className="mb-3 text-sm font-semibold tracking-widest text-purple-800 uppercase">
                Support
              </h2>
              <nav className="mb-10 list-none">
                <li className="mt-2">
                  <a
                    href="/faq"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    FAQ
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/track_parcel"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    Track Parcel
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    Get a Quote
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/developers"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    API Docs
                  </a>
                </li>
              </nav>
            </div>
            <div className="w-full px-4 lg:w-1/4 md:w-1/2">
              <h2 className="mb-3 text-sm font-semibold tracking-widest text-purple-800 uppercase">
                Contact Info
              </h2>
              <div className="mb-10">
                <div className="mt-2">
                  <p className="text-gray-600 text-sm font-medium">Warehouse Address:</p>
                  <p className="text-gray-600 text-sm">
                    Gallagher Business Exchange<br />
                    Office Park, 688 Gallagher Ave<br />
                    Halfway House, Midrand, 1685
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-gray-600 text-sm">
                    <span className="font-medium">Service Area:</span> 70km radius
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full px-4 lg:w-1/4 md:w-1/2">
              <h2 className="mb-3 text-sm font-semibold tracking-widest text-purple-800 uppercase">
                Legal
              </h2>
              <nav className="mb-10 list-none">
                <li className="mt-2">
                  <a
                    href="/terms"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    Terms of Service
                  </a>
                </li>
                <li className="mt-2">
                  <a
                    href="/privacy"
                    className="text-gray-600 cursor-pointer hover:text-purple-700 transition-colors text-sm"
                  >
                    Privacy Policy
                  </a>
                </li>
              </nav>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-purple-600 to-indigo-600">
          <div className="container px-5 py-3 mx-auto">
            <p className="text-sm text-white text-center">
              © 2025 Earlybirds Corporation (PTY) Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};
